/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Japanese language
 *
 * @file ja.js
 * @author Manimaran.S
 */
const ja = {
  'popularChannelSlider.allChannels': 'すべてのチャンネル',
  'popularChannelSlider.recommended': '推奨',
  'hero.myetextbook.link': 'ライブラリ',
  'hero.myetextbook.text': 'タイトルが間違っている場合、eTextブックライブラリにアクセスしてください：',
  'hero.etextfeaturestitle': 'eTextブックで学習教材を探す',
  'hero.etextfeaturesdescription': 'eTextブックには、お客様の成功をサポートする学習教材が付属しています。フラッシュカードなどを使って学習できます。',
  'aichat.title1': 'このeTextブックに関連するあらゆることについて、AIを活用したサポートを受けられます。',
  'aichat.chatDesc1': '問題を入力して開始',
  'subscriptiontext.isSubscribed': 'サブスクリプションの一部',
  'subscriptiontext.nonSubscriber': 'アップグレードして完全なアクセスを得る',
  'topicConatiner.otherHeader': '関連する動画と演習',
  'topicConatiner.exactLiteHeader': '関連する概念と演習',
  'moremenu.downloadApp': 'アプリをダウンロード',
  'moremenu.downloadAppAlreadyDownload': 'こちら (%Click here%) をクリックすることで、別のデバイスにアプリをダウンロードして自動的にサインインしたり、固有のQRコードを使用して既にインストールされているアプリに安全にサインインしたりできます。',
  'moremenu.downloadAppNotDownload': 'こちら (%Click here%) をクリックすると、アプリをダウンロードし、固有のQRコードで安全にサインインできます',
  'channel.noBundletitle': '関連コースや他のコースの学習準備をご利用ください',
  'onboard.studyPlan': 'カスタム学習プランが作成されました。',
  'onboard.addCourseAnother': '他のコースを追加しますか？',
  'onboard.purchase': 'PearsonのeTextブックを購入する必要があります',
  'onboard.addCourseWithoutEtext': '学習準備を使用してコースを追加する',
  'onboard.mayBeLater': '後でする',
  'onboard.aboutCourse': 'コースについて教えてください',
  'onboard.close': '閉じる',
  'course.addTitle': 'コースを追加',
  'common.PURCHASE': '購入',
  'common.CLOSE': '閉じる',
  'open': '開く',
  'continue': '続ける',
  'yes': 'はい',
  'no': 'いいえ',
  'audio': 'オーディオ',
  'courses.toc.PUBLISH_SUCCESS': '成功！',
  'courses.toc.PUBLISH_MESSAGE': '生徒が次にコンテンツを開いたときに、変更が表示されます。',
  'errors.GENERIC_TITLE': '現在アクセスできません',
  'errors.GENERIC_DESC': 'まず、キャッシュを更新またはクリアしてください。それでも解決しない場合は、Pearsonにお問い合わせください。',
  'errors.GENERIC_LINK': 'サポート',
  'errors.GENERIC_CODE': 'エラーコード：{code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'サブスクリプションが見つかりません',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'アカウントには、このタイトルへのアクセスが含まれていません。このメッセージを誤って受け取ったと思われる場合は、\n      Pearsonテクニカルサポートにお問い合わせください。',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'サブスクリプションが見つかりません',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'サブスクリプションにはeTextへのアクセスは含まれていませんが、クレジットカードを使用して今すぐサブスクライブできます。',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': '私のアカウント',
  'menu.helpCenter': 'ヘルプセンター',
  'menu.preferencesCenter': 'プリファレンスセンター',
  'menu.CONTACT_SUPPORT': 'サポートに連絡',
  'menu.HELP_SUPPORT': 'ヘルプ&サポート',
  'menu.FAQS': 'よくある質問（FAQ）',
  'menu.CHAT_WITH_SUPPORT': 'サポートとチャット',
  'menu.OTP_CODES': 'OTPコード',
  'menu.LAUNCH_CODE': 'コードログの立ち上げ',
  'menu.SEND_CODE': '電子メールでユーザーの新しいコードを送信',
  'menu.SEND_CODE_PHONE': 'テキストメッセージでユーザーの新しいコードを送信',
  'menu.LEGAL': '法的情報',
  'menu.PRIVACY_NOTICE': 'プライバシー通知',
  'menu.TITLE_INFO': 'タイトル情報',
  'menu.PEARSON_ACCESSIBILITY': 'ピアソンアクセシビリティ',
  'menu.DEVICE_WARNING_MESSAGE': '{deviceLimit}台登録可能です。月に1台ずつ交換可能です。',
  'menu.ACCESSIBILITY': 'アクセシビリティ',
  'menu.ACCESSIBILITY_SUPPORT': 'アクセシビリティサポート',
  'menu.DEVICES': '最近のデバイス',
  'menu.THIS_DEVICE': '最近のデバイス',
  'menu.GET_THE_APP_DOWNLOAD': 'モバイルアプリのダウンロード',
  'menu.MOJO_APP_INFO': 'オフラインでPearson+をご利用いただくには、お手持ちの携帯電話やタブレットのアプリストアにアクセスしてください。',
  'menu.DEVICE_LABEL': 'デバイス',
  'menu.DEVICE_DISCONNECT': '接続解除',
  'menu.FOXIT': 'Powered by Foxit',
  'menu.TERMS_OF_USE': '利用規約',
  'menu.SIGN_OUT': 'サインアウト',
  'menu.PRINT_PAGE': 'ページを印刷',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': '{fullName}（{email}）によって{currentDate}に印刷されました。',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': '今月はすでに交換しています',
  'device.SWITCH_DEVICE': '現在のデバイスに切り替えますか？',
  'device.SWITCH_ONCE': '切り替えができるのは月に1回のみのため、元に戻すことはできません。',
  'device.SEAT_TAKEN': '席がいっぱいです',
  'device.DISCONNECT_DEVICE': 'ログインできるデバイスの台数は3台のみです。続行するには、他のデバイスの接続を解除してください。',
  'device.ALERT_TEXT': 'なお、デバイスの交換は1ヶ月に1回しかできません。',
  'device.DISCONNECT': '接続解除',
  'device.CONTINUE': '続ける',
  'device.HEADER': '他ブラウザのセッションを終了しますか？',
  'device.CLOSE': 'ホームに戻る',
  'device.CODE': '{maskedEmail}に送信した認証コードを入力して、こちらで続行してください。うまくいかない場合は、スパムフォルダ、{email}を確認するか、{support}までお問い合わせください。',
  'device.TIMER': 'こちらにコードを入力できる時間は{time}です',
  'device.RESEND': '{resend}',
  'device.FAQ': 'よくある質問',
  'device.RESEND_NAME': '再送信',
  'device.NOTE': 'Pearson+を職場と自宅など2か所で定期的に使用する場合は、使用後は必ずログアウトしてください。Pearson+モバイル アプリは最大2台のデバイスで使用できます。詳細については、{faq}をご覧ください。',
  'device.NOTE_HEADER': '次回はこれを避ける',
  'device.CONTACT_SUPPORT': 'カスタマーサポート',
  'device.CONTACT_EMAIL': 'お客様のメールアドレスを更新',
  'device.INCORRECT': '不正確です—コードをもう一度確認するか、再送信してください。',
  'device.MANY_ATTEMPTS': '試行回数の上限を超えたため、コードの再送信をお試しください',
  'device.EXPIRED': '時間切れになりました。コードの再送信をお試しください',
  'device.ACCESS_HEADER': '認証されました！',
  'device.ACCESS_DESC': 'セッションが認証されました。セッション中にパスワードを更新しますか？',
  'device.ACCESS_CHANGE_PASSWORD': 'パスワードを変更',
  'device.ACCESS_RESET_PASSWORD': 'パスワードをリセット',
  'device.THREATONE_TITLE': '問題はございませんか？',
  'device.THREATONE_DESC': 'お客様のアカウントで不審なアクティビティが検出されました',
  'device.THREATONE_DESC_TWO': 'パスワードを変更されることをおすすめします。',
  'device.MAY_BE_LATER': '後でする',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': '安全性を保つために、お客様をログアウトしました。お客様のアカウントに関連付けられたメールアドレスに、パスワードリセット用リンクを送信しました。',
  'device.ACCOUNT_LOCK_TITLE': 'お客様のアカウントで不審なアクティビティが検出されました',
  'device.ACCOUNT_LOCK_TIMER': 'ログアウトまであと {time}',
  'navigation.PAGE': 'ページ',
  'launchcode.CREATEBY': '作成者：',
  'launchcode.sentvia': '送信元:',
  'launchcode.CODEINLAST': '直近7日間のコード：',
  'launchcode.TIMESENT': '送信時刻：',
  'launchcode.ACCOUNTEMAIL': 'アカウントのメールアドレス：',
  'launchcode.LAUNCHDIALOGTITLE': 'OTPコードログ',
  'textmessage.TITLE': '携帯番号を入力する',
  'textmessage.PHONE_NUMBER': '電話番号',
  'textmessage.SEND_CODE': 'コードを送信',
  'textmessage.INVALID_NUMBER': '電話番号が無効です。',
  'textmessage.SUCCESS_MESSAGE': 'リンクが送信されました',
  'remove.title': 'タイトルを削除しますか？',
  'remove.subTitle': '後でいつでも元に戻すことができます—検索を使用して再度追加してください。',
  'remove.buttonText': '削除',
  'search.searchPlaceHolderPPlus': 'ISBN、タイトル、著者で検索',
  'search.searchPlaceHolderEText': 'ライブラリを検索',
  'footer.downloadMobileApp': 'モバイルアプリのダウンロード',
  'footer.termsOfUse': '利用規約',
  'footer.privacy': 'プライバシー',
  'footer.cookies': 'Cookie',
  'footer.doNotSellMyPersonalInformation': '個人情報を販売しないでください',
  'footer.accessibility': 'アクセシビリティ',
  'footer.patentNotice': 'プライバシー通知',
  'footer.copyrights': 'Pearson 無断複写・複製・転載を禁ず。',
  'hero.toc.defaultPlacehoder': '---トピックを選択---',
  'hero.openEtextBookV1': 'eTextブックを開く',
  'hero.heroHeading': 'なぜならあなたは <span>{channel_title}</span>を学習中だからです',
  'hero.heroHeadingForBundleUser': '学習準備',
  'hero.study.help': '学習サポートを手に入れましょう',
  'hero.study.jumpBackIn': 'ジャンプして戻る',
  'hero.study.numOfUsers': '現在 <b>{num_of_users}</b> 人の生徒がチャンネルを使用しています。',
  'hero.heroChannel.cardsHeading': '中断したところから続けましょう',
  'hero.marketingcard1.copy.title': 'ビデオで学習しましょう',
  'hero.marketingcard1.copy.description': '難しいトピックをわかりやすく教えてくれる簡単なビデオ説明を見ましょう。',
  'hero.marketingcard2.copy.title': '演習問題',
  'hero.marketingcard2.copy.description': '数千問の模擬試験問題やビデオ教材で試験準備をしましょう',
  'hero.marketingcard3.copy.title': '経験豊富なサポートを得ましょう',
  'hero.marketingcard3.copy.description': '質問を投稿してその分野の専門の先生から回答を得られます。',
  'hero.popularTopics.heading': 'このチャンネルのその他の人気のあるトピック',
  'hero.popularChannels.headingv1': '他のコースを受講しますか？',
  'hero.popularChannels.descriptionv2': '人気のある学習サポートトピックを見てみましょう。',
  'hero.practice': '演習',
  'hero.herobook.mappedChannelHeading': 'このチャンネルでのおすすめの学習サポート',
  'libraryL2.myBooks': 'マイブック',
  'libraryL2.archived': 'アーカイブ済み',
  'libraryL2.back': '戻る',
  'hero.practiceProblem': '演習問題',
  'nativeAppBanner.drawer.title': '次で開く...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+アプリ',
  'nativeAppBanner.banner.title': 'Pearson+アプリ',
  'nativeAppBanner.banner.description': '外出中に学習',
  'hero.promotionalcard.list1': '難しいトピックをわかりやすく教えてくれる簡単なビデオ',
  'hero.promotionalcard.list2': '数千問の模擬試験問題',
  'hero.promotionalcard.list3': 'その分野の専門の先生からの回答を得る',
  'hero.studyandexamprep': '学習準備',
  'hero.heroBook.sectionSubHeadingV1': 'コースに合わせたビデオの説明と演習問題で難しいトピックをわかりやすく覚えましょう。',
  'hero.heroBook.sectionSubHeadingV2': 'コースに合わせた概念の説明と演習問題で難しいトピックをわかりやすく覚えましょう。',
  'hero.SeeAllStudyOptions': 'すべての学習オプションを表示',
  'hero.herobook.mappedChannelHeadingV1': 'おすすめ動画と練習問題',
  'hero.popularTopics.headingV1': 'その他の人気トピック',
  'hero.heroHeadingV1': '<span>{replace_value}</span>向け',
  'hero.learnmore': '詳細を見る',
  'hero.eTextbook': 'eTextブック',
  'hero.goToPage.label': 'ページへ移動する',
  'subscription.studyTitle': '学習準備',
  'print.printAvailTitle': 'このページを印刷する場合、方法はこちらです。',
  'print.printAvailDesc': 'eTextブックで、右上のアカウントアイコンを選択します。オプションから「ページを印刷」を選択し、印刷設定を選択します。',
  'print.printNotAvailTitle': 'このeTextの印刷オプションは有効になっていません。',
  'print.printNotAvailDesc': 'オフラインでも利用できるように、Pearson+モバイルアプリから教材をダウンロードしてください。いつでもどこでも、自分のペースで学習できます。',
  'hero.header.cta': '学習ツールに移動',
  'hero.header.ctav2': '学習準備を開く',
  'hero.marketing.title': 'eTextブックを見つける',
  'hero.marketing.subTitle': 'オーディオ、フラッシュカード、メモなどが付いた2,000冊以上のeTextブックからお選びいただけます。4か月間で月額わずか10.99ドルです。',
  'hero.popularchannels.desc': 'これらの人気科目で学習サポートを手に入れましょう。',
  'hero.removecourse.title': 'ダッシュボードからコースを削除しますか？',
  'hero.removecourse.description': '「コースを追加」をクリックすると、いつでもダッシュボードにこちらのコースを追加できます。',
  'hero.removecourse.primaryCtaText': '削除',
  'hero.removecourse.secondaryCtaText': 'キャンセル',
  'hero.tableOfContents': '目次',
  'hero.search': '検索',
  'hero.emptystate.cta': 'eTextブックを検索',
  'hero.watch_it_again': 'もう一度見る',
  'hero.mondly.learnLang.title': '新しい言語を無料で学ぶ',
  'hero.mondly.subTitle': 'Pearson eTextブックユーザーならMondly by Pearsonを3か月無料でご利用いただけます。',
  'hero.mondly.description': 'ほとんどの語学学習アプリは英語で学ぶようになっています。しかし、お客様の母語から学ぶのが一番良いため、Mondlyは41の言語のいずれかで学ぶことが可能です。',
  'hero.mondly.startLearningCTA': '学習を開始する',
  'hero.mondly.marketing.bestApp': 'ベストアプリ',
  'hero.mondly.marketing.appStore': 'アプリストア',
  'hero.mondly.marketing.appYear': '年間最優秀アプリ',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017年EMEA地域優勝',
  'hero.mondly.marketing.editorChoice': '編集者のおすすめ',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': '語学学習',
  'header.menu.moreAtPearson': 'Pearsonの詳細を見る',
  'hero.subscriptionStatusTitle2': 'お客様のPearson+のリソース',
  'hero.startStudying': '学習を開始する',
  'onboard.studyMaterials': '科目を選択すると、カスタマイズされた学習教材を含むダッシュボードが作成されます。',
  'hero.myETextbooks': '私のeTextブック',
  'header.continueInTheApp': 'アプリで続ける',
  'hero.learnTxt': '学習',
  'hero.examPrepTxt': '試験準備',
  'hero.aITutorTxt': 'AIチューター',
  'AI.toolTip': 'eTextブックに関することは、何でもお問い合わせください',
  'hero.studyExamPrepAllYourCourses': 'お客様の全てのコース向け学習および試験準備',
  'header.qrCode.subHeaderTxt': 'このQRコードを使用すると、モバイルデバイスのPearson+アプリにすばやく安全にサインインできます。',
  'header.qrCode.dontHaveApp': 'アプリをお持ちではありませんか？',
  'header.qrCode.footerTxt': 'このコードをスキャンすると、アプリストアまたはGoogle Playにリダイレクトされます。アプリがダウンロードされたら、もう一度スキャンしてサインインしてください。',
  'header.qrCode.errorMsg': 'QRコードが読み込めませんでした。閉じてやり直してください。',
  'hero.yourETextbook': '自分のeTextブック',
  'onboard.addCourseWithEtextBundle': '学習準備を使用してコースを追加する',
  'onboard.disableTooltipText': '全ての学習準備コースが追加されました。',
  'subscriptionstatus.bundlecta': '学習準備へアクセスする',
  'subscriptionstatus.nonbundlecta': '学習準備へアクセスする',
  'channel.genericBundle': '学習準備を他のコースの学習に活用しましょう',
  'channel.relatedBundle': '学習準備を他のコースの学習にも活用しましょう',
  'onboard.courseAdded': 'コースが追加されました。',
  'hero.flashcards': 'フラッシュカード',
  'relatedChannelCard.title': 'こちらの関連リソースで学習を深めましょう',
  'relatedChannelCard.badgeText': '学習準備関連',
  'sessionInactivity.title': 'まだいらっしゃいますか？',
  'sessionInactivity.description': 'アクティブではないため、セッションは <b>{TIMER}</b> 後にタイムアウトします。<br/>サインインしたままにしますか？',
  'sessionInactivity.keepMeSignIn': 'サインインしたままにする',
  'sessionInactivity.signOut': 'サインアウト',
  'sessionTimeout.title': 'セッションがタイムアウトしました',
  'sessionTimeout.description': 'アクティブではなかったため、セッションがタイムアウトしました。',
  'print.qrCode.header': 'このQRコードを使用すると、モバイルデバイスのPearson+アプリを開けます。',
  'print.qrCode.footer': 'このコードをスキャンすると、アプリストアまたはGoogle Playにリダイレクトされます。アプリがインストールされたら、サインインしてタイトルをダウンロードし、それにアクセスしてください。',
  'hero.nestest.title': '教員資格試験の準備をする',
  'hero.nestest.subTitle': 'Pearson+のユーザーは、教員資格試験に向けて学習できるよう、全国基準に準拠した試験対策コースや模擬試験を利用できるようになりました。',
  'hero.channelAI.title': '何かお困りでしょうか。AIチューターがお助けします。',
  'hero.channelAI.desc': '質問すると、宿題のステップバイステップのヘルプ、おすすめの学習など、必要なときにいつでもご自身に合ったサポートを受けられます。',
  'hero.channelAI.action': '今すぐAIチューターに質問',
  'new': '新規！',
  'hero.practice.numOfUsers': 'このセクションには<b>{practice_num_of_users}</b>件の演習問題があります',
  'hero.practice.cta': '今すぐ演習をする',
  'hero.practice.title': '演習問題',
  'diagnostics.errorMsg': '診断が読み込めませんでした。閉じてやり直してください。',
  'qrcode.title': 'どこからでも学習を始めよう',
  'qrcode.subtitle': 'Pearson+モバイルアプリを使えば、いつでもどこでも学習できます。今すぐダウンロードして、シームレスな学習体験を実感しましょう。',
  'qrcode.detailsv1': 'Pearson+アプリでこのQRコードを読み取ると、前回の続きから学習を再開できます。書籍の検索、フラッシュカードを使った学習、ビデオレッスンの視聴など、さまざまな機能をどこにいてもご利用いただけます。',
  'qrcode.detailsv2': 'すばやくログインして前回の続きから学習を再開するには、このQRコードを読み取ってください。',
  'qrcode.details': 'Pearson+アプリでこのQRコードを読み取ると、前回の続きから学習を再開できます。',
  'qrcode.appstore': 'アプリストア',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Pearson+モバイルアプリを使えば、いつでもどこでも学習できます。今すぐダウンロードして、シームレスな学習体験を実感しましょう。',
  'install': 'Install',
  'header.menu.createCourse': '新しいコース',
  'header.dropdown.courses': 'コース',
  'header.dropdown.recentlyViewed': '最近の閲覧',
  'header.dropdown.viewAll': 'すべてのコースを表示',
  'aet.courseHeader.inviteStudents': '生徒を招待',
  'aet.courseHeader.inviteStudentModal.subTitle': '下記のリンクアドレスまたは手順をコピーしてメールやシラバスに貼り付けることで、学生にこのeTextブックへのアクセスを促せます。',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'リンクアドレス',
  'aet.courseHeader.inviteStudentModal.copyLink': 'リンクをコピー',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'リンクアドレス付きの手順',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'コピー手順',
  'aet.courseHeader.inviteStudentModal.instructionIntro': '{courseName}のeTextブックである{bookTitle}にアクセスするタイミングです。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': '準備ができたら、{enrollmentLink}からeTextブックにアクセスしてください。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': '既存のPearsonアカウントでログインするよう求められます。Pearsonアカウントをお持ちでない場合は、新規作成できます。\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'サポートが必要な場合',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': '開始日：',
  'aet.courseHeader.endDate': '終了日：',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': '形式：',
  'aet.home.manageroster': '名簿の管理',
  'aet.home.managegradesync': '成績同期の管理',
  'aet.home.copycourse': 'コースをコピー',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.alertBannerMessage': 'Temporary access ends in {days} days. Upgrade to avoid interruptions.',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',
  'aet.tempAccess.manageRoster.bannerMessage': 'One or more students have temporary access that has expired or may expire before all assignments are due.',
  'aet.tempAccess.manageRoster.emailActionLabel': 'Get student emails and access instructions',
  'aet.tempAccess.manageRoster.email.title': 'Student emails and access instructions',
  'aet.tempAccess.manageRoster.email.subTitle': 'Help students maintain access to their eTextbook by sharing the following instructions',
  'aet.tempAccess.manageRoster.email.recipientsLabel': 'Affected student email addresses',
  'aet.tempAccess.manageRoster.email.instructionsLabel': 'Access instructions',
  'aet.tempAccess.manageRoster.email.greeting': 'Dear Student,',
  'aet.tempAccess.manageRoster.email.paragraph1': 'Your temporary access for {courseName} may no longer be active. To maintain access to your eTextbook and your reading assignments, upgrade your access as soon as possible.',
  'aet.tempAccess.manageRoster.email.paragraph2': 'Once you\'ve accessed your course, you should see a prompt to upgrade. If not, follow these steps:',
  'aet.tempAccess.manageRoster.email.bullet1': 'Go to my account by selecting the circle with your initials in the upper right',
  'aet.tempAccess.manageRoster.email.bullet2': 'Go to Manage subscription',
  'aet.tempAccess.manageRoster.email.bullet3': 'Look for your eTextbook and follow the prompts to upgrade your access',
  'aet.tempAccess.manageRoster.email.footerPrefix': 'You can find detailed directions for how to upgrade, including a video walkthrough here: ',

  'aet.instructorCourse.tabs.current': '現在',
  'aet.instructorCourse.tabs.past': '過去',
  'aet.instructorCourse.tabs.courseSettings': 'コース設定',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': '名簿の管理',
  'aet.instructorCourse.currentCourses.title': '現在のコース',
  'aet.instructorCourse.pastCourses.title': '過去のコース',
  'aet.instructorCourse.createOrCopy.title': 'PearsonのeTextブックコースを作成またはコピー',
  'aet.instructorCourse.createOrCopy.sectionTitle': '他のインストラクターのコースをコピーするか、新しいコースを作成',
  'aet.instructorCourse.createOrCopy.copyPanel.title': '他のインストラクターのコースをコピー',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'コピーしたいコースを探すには、コースIDを入力してください。',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'コースID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'コースIDを入力',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': '次を検索しました:',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'カタログから新しいコースを作成',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'タイトル、著者名、ISBN、または科目に関するキーワードで検索できます。',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': '検索...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': '表示を増やす',
  'aet.instructorCourse.createOrCopy.showLessLabel': '表示を減らす',
  'aet.instructorCourse.cancel': 'キャンセル',
  'aet.instructorCourse.loading': 'ロード中…',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': '成績同期',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': '成績同期の管理',
  'aet.instructorCourse.courseForm.courseNameLabel': 'コース名',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': '無題',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'セクション名',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': '無題',
  'aet.instructorCourse.courseForm.institutionFieldLabel': '所属組織',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': '所属組織が必要となります',
  'aet.instructorCourse.courseForm.institutionSearchError': 'エラーが発生しました。もう一度お試しください。',
  'aet.instructorCourse.courseForm.institutionNoResults': '結果はありません',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.k12EmptyStateHeadline': 'Creating a K–12 course?',
  'aet.instructorCourse.courseForm.k12EmptyStateDescription': 'You\'ll have to create it outside Pearson+. After that\'s complete, you\'ll be able to manage it here.',
  'aet.instructorCourse.courseForm.startDateLabel': 'コース開始日',
  'aet.instructorCourse.courseForm.endDateLabel': 'コース終了日',
  'aet.instructorCourse.courseForm.datePlaceholder': '日/月/年',
  'aet.instructorCourse.courseForm.allowCopyLabel': '他の人がこのコースをコピーできるようにする',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'このコースをコピーしたいインストラクターに、このコードを共有してください',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'コードをコピー',
  'aet.instructorCourse.courseForm.optionalSuffix': '（オプション）',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'フォームに検証エラーがあります',
  'aet.instructorCourse.courseForm.submitContinue': '続ける',
  'aet.instructorCourse.courseForm.submitContinueLoading': '保存しています…',
  'aet.instructorCourse.courseForm.submitError': 'コースを作成できませんでした。もう一度お試しください。',
  'aet.instructorCourse.courseForm.submitEditError': '変更内容を保存できませんでした。もう一度お試しください。',
  'aet.instructorCourse.courseForm.submitSaveChanges': '変更を保存',
  'aet.instructorCourse.courseForm.materialsHeader': 'コース教材',
  'aet.instructorCourse.courseForm.resolveError': 'コース教材を読み込むことができませんでした。もう一度お試しください。',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': '最終表示日',
  'aet.instructorCourse.coursesSort.recentlyAdded': '最新の追加',
  'aet.instructorCourse.coursesSort.aToZ': 'AからZ',
  'aet.instructorCourse.coursesSort.zToA': 'ZからA',
  'aet.instructorCourse.manageRoster.column.name': '名前',
  'aet.instructorCourse.manageRoster.column.role': '役割',
  'aet.instructorCourse.manageRoster.column.email': 'メール',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': '状態',
  'aet.instructorCourse.manageRoster.enrolledDate': '{date} に登録済み',
  'aet.instructorCourse.manageRoster.enrolledLabel': 'Enrolled:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.access.expired': 'Expired',
  'aet.instructorCourse.manageRoster.access.tempAccessDays': '{days}-day temp access',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.manageRoster.access.active': 'Active',
  'aet.instructorCourse.manageRoster.access.inactive': 'Inactive',
  'aet.instructorCourse.manageRoster.access.tempAccess': 'Temporary',
  'aet.instructorCourse.roster.role.student': '生徒',
  'aet.instructorCourse.roster.role.ta': 'TA',
  'aet.instructorCourse.roster.role.instructor': 'インストラクター',
  'aet.instructorCourse.roster.status.active': '有効',
  'aet.instructorCourse.roster.status.inactive': 'アクティブではない',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'すべてのメンバー',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'アクティブな生徒',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'あまりアクティブでない生徒',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'ティーチングアシスタント',
  'aet.instructorCourse.manageRoster.filter.instructor': 'インストラクター',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': '著者：',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN：',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'コース作成日：',
  'aet.instructorCourse.noCoursesFound': 'コースが見つかりませんでした',
  'aet.instructorCourse.backButton': '戻る',
  'aet.instructorCourse.selectCourse': 'コースを選択',
  'aet.home.linkedToLms': 'LMSにリンクされています',
  'aet.instructorCourse.courseForm.title.create': 'コースを作成',
  'aet.instructorCourse.courseForm.title.copy': 'コースをコピー',
  'aet.instructorCourse.courseForm.title.edit': 'コースの情報',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': '課題',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': '課題の内容',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': '課題提出期限',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'ハイライトとメモ',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'ハイライトカラー',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'テキストをメモ',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': '共有ステータス',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': '生徒名簿と生徒の参加状況',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': '生徒の名前',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'メールアドレス',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': '登録',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': '完了とインサイト',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': '設定',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'コピーされたデータ',
  'aet.studentRoster.manageStudentRosterButton': '生徒名簿を管理',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': '生徒の進捗状況のエクスポート',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'ステータス：',
  'aet.home.student.roaster.enrolmentInformation.enrolled': '登録済み：',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': '役割：',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': '{studentName}を昇格させますか？',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'ティーチングアシスタントとして、このクラスの全生徒の進捗状況と成績を把握する権限できるようになります。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': '生徒や課題を管理することはできますが、クラスを削除することはできません。',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'ティーチングアシスタントに昇格',
  'aet.home.manageRoster.searchPlaceholder': '生徒を検索',
  'aet.home.manageRoster.inactivateButtonLabel': '選択した生徒を非アクティブ化',
  'aet.home.manageRoster.FilterLabel': '表示',
  'aet.home.manageRoster.updatingMessage': '名簿を更新中…数分かかる場合があります。',
  'aet.home.courses.search.searchPlaceHolder': 'コースを検索',
  'aet.courses.emptyStateDescription': '以下のオプションから選択して、コースの作成を開始してください。',
  'nativePromoBanner.continueInBrowser': 'ブラウザで続行',
  'globalnav.tooltip.hideNavText': 'ナビゲーションを非表示',
  'globalnav.tooltip.showNavText': 'ナビゲーションを表示',
  'aet.syllabus.progressTitle': '抽出しています…',
  'aet.syllabus.progressDesc': 'シラバスを処理しています。しばらくお待ちください。',
  'aet.syllabus.uploadInputLabel': 'ファイルをドラッグ＆ドロップするか、クリックしてアップロード',
  'aet.syllabus.uploadSyllabusTabLabel': 'シラバスをアップロード',
  'aet.syllabus.dateAdjusterTabLabel': '日付調整ツール',
  'aet.syllabus.addManuallyTabLabel': '課題を手動で追加',
  'aet.syllabus.addEditLaterText': '課題は後からいつでも追加・編集できます',
  'aet.syllabus.editAssignmentLabel': '課題を編集',
  'aet.syllabus.addAssignmentLabel': '課題を追加',
  'aet.syllabus.assignmentTitleLabel': '課題タイトル',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': '提出期限',
  'aet.syllabus.editDueDateLabel': '編集期日',
  'aet.syllabus.chaptersCoveredLabel': '扱うチャプターまたはセクションを選択してください。',
  'aet.syllabus.updateCtaLabel': '課題を更新',
  'aet.syllabus.addCtaLabel': '課題を追加',
  'aet.syllabus.uploadLabel': 'アップロード',
  'aet.syllabus.confirmLabel': '確定',
  'aet.syllabus.addContentLabel': 'コンテンツを追加',
  'aet.syllabus.addEditContentLabel': 'コンテンツの追加/編集',
  'aet.syllabus.notPublishedLabel': '未公開',
  'aet.syllabus.updateDatesLabel': '更新日',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': '期日が更新されました。内容を確認して公開してください。',
  'aet.syllabus.coverageDedupe.adjustedContent': 'チャプター/セクションの情報が更新されました。内容を確認して公開してください。',
  'aet.syllabus.unassignedCoverageStatus': 'まだ割り当てられていないチャプターがあります。公開前に割り当ててください。',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': '課題を削除しますか？',
  'aet.deleteAssignmentTitleMultiple': '課題を削除しますか？',
  'aet.deleteAssignmentWarning': 'この操作は元に戻せません。関連する提出物や生徒データは表示されなくなります。',
  'aet.deleteAssignmentKeepCTA': '課題を保持',
  'aet.deleteAssignmentDeleteCTA': '削除',
  'aet.assignments.loadingAsset': 'アセットを読み込み中...',
  'aet.assignments.addToDate': '日付に追加',
  'aet.assignments.previewAsStudent': '生徒としてプレビュー',
  'aet.assignments.questionsAndTopics': '質問とトピック',
  'aet.assignments.questionsAndTopicsModal.doneLabel': '完了',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': '提出期限',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': '質問合計',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': '質問 {count} / {total}',
  'aet.assignments.publishToStudents': '学生向けに公開',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': '日付を追加',
  'aet.doneLabel': '完了',
  'aet.assignments.dueDateLabel': '課題の期日',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now',
  'aet.onboarding.getStarted.manualSetup.title': '手動セットアップ',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Assisted scheduling',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Automatically set all due dates and easily add chapter content from your eTextbook',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Hold students accountable with assigned reading',
  'aet.onboarding.promotion.feature.1': 'Create multiple assignments within minutes, with optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'リアルタイムの学習データから理解不足を把握し、早い段階で適切に対応できます',
  'aet.onboarding.promotion.feature.3': '生徒は、個別に最適化されたフィードバックとPearson AIによるサポートを受けられます',
  'aet.assistedSchedule.pageTitle': 'Assisted scheduling',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set a recurring assignment schedule',
  'aet.assistedSchedule.sectionDescription': 'We\'ll create assignment slots throughout your course that you can populate with content from your eTextbook.',
  'aet.assistedSchedule.dueDaysLabel': 'Due day(s)',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Starts on',
  'aet.assistedSchedule.endDateLabel': 'Ends on',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assignments.allCaughtUpDescription': '今週が期限の課題はありません。',
  'aet.assignments.progressTitle': '進捗',
  'aet.assignments.performanceTitle': '自信',
  'aet.assignments.completionTitle': '完了',
  'aet.assignments.statusTitle': '状態',
  'aet.assignments.addTooltip': '課題を追加',
  'aet.assignments.deleteTooltip': '選択した課題を削除',
  'aet.assignments.selectToDeleteLabel': '一括削除モード',
  'aet.assignments.bulkEditTooltip': '課題を一括編集',
  'aet.assignments.title': '課題',
  'aet.assignments.assignmentTitle': '課題',
  'aet.assignments.dueDate': '提出期限',
  'aet.tabular.searchPlaceholder.assignments': '課題を検索',
  'aet.tabular.searchPlaceholder.students': '生徒を検索',
  'aet.tabular.searchPlaceholder.questions': '質問を検索',
  'aet.assignemnts.columnDueDateInfoTooltip': '1名以上の生徒の全課題の期日が延長されました。',
  'aet.assignemnts.singleDueDateInfoTooltip': '1名以上の生徒に、この課題の期日延長が認められました。',
  'aet.assignemnts.masterDueDateInfoTooltip': '1名以上の生徒に期日の延長が認められました。該当する課題は、情報アイコンで確認できます。',
  'aet.home.loading': 'ロード中…',
  'aet.home.errorFetchingAssignments': '課題の取得に失敗しました',
  'aet.home.dueThisWeekTitle': '今週期限',
  'aet.home.allCaughtUpTitle': 'これで全部完了です。',
  'aet.home.allCaughtUpDescription': '今週が期限の課題はありません。',
  'aet.home.suggestedRemediationTitle': '学習準備による再確認の提案',
  'aet.home.noSuggestedRemediationTitle': '推奨されている復習教材はありません。',
  'aet.home.noSuggestedRemediationDescription': '次の課題のあとに再確認してください。',
  'aet.home.assignmentIncludesTitle': '課題に含まれるもの',
  'aet.home.sectionsLabel': 'チャプター',
  'aet.home.questionsCount': '{count} つの質問',
  'aet.home.dueLabel': '期限：{dueDate}',
  'aet.home.due': '期限:',
  'aet.home.progressCompletedLabel': '完了済み',
  'aet.home.progressCompletedPastDueLabel': '完了済み（期限後提出）',
  'aet.home.progressInProgressLabel': '進行中',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': '未開始',
  'aet.home.progressCountOfTotal': '{count} / {total}',
  'aet.home.NotAttemptedLabel': '未回答',
  'aet.home.questionsTotalLabel': '問題数合計',
  'aet.home.progressCompletedOnTimeLabel': '期限内に完了',
  'aet.home.segmentGreatLabel': 'とても良い',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': '要改善',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': '課題を編集',
  'aet.home.deleteAssignmentTooltip': '課題を削除',
  'aet.home.viewDetailsButton': '詳細を表示',
  'aet.home.viewAsStudentButton': '生徒として表示',
  'aet.home.welcomeButtonText': '始めましょう →',
  'aet.review.emptyStateTitle': '復習が必要なものはありません',
  'aet.review.emptyStateDescription': '次の課題のあとに再確認してください。',
  'aet.dashboard.tabs.upNext': '次へ',
  'aet.dashboard.tabs.welcome': 'ようこそ',
  'aet.dashboard.tabs.assignments': '課題',
  'aet.dashboard.tabs.review': '確認',
  'aet.dashboard.tabs.studentRoster': '生徒',
  'aet.dashboard.classSchedule': 'クラススケジュール:',
  'aet.syllabus.dueTimeLabel': '提出時刻',
  'hero.accessEducatorGuides': '教育者ガイドにアクセス',
  'aet.assignment.save': '保存',
  'aet.assignment.finish': '終了する',
  'aet.assignment.saveAndAdd': '保存して追加',
  'aet.assignment.delete': '削除',
  'aet.assignment.saveAndClose': '保存して閉じる',
  'aet.studentRoster.title': '生徒',
  'aet.studentRoster.titlev1': '生徒',
  'aet.studentRoster.dueDatesAdjustmentLabel': '期日',
  'aet.studentRoster.dueDateAdjustment.option.0': '標準',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2日',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3日',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5日',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1週間',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2週間',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'クラス最終日',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count}件の課題が更新されました',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '期日を過ぎた課題が自動的に更新できませんでした。各課題を編集して、新しい期日を設定してください。',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': '期日を更新できません',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'すべての課題の期日が過ぎており、自動的に更新できませんでした。各課題を編集して、新しい期日を設定してください。',
  'aet.bulkEdit.bulkSplitInstruction': '課題は均等に割り当てられます。',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': '最初の課題の提出期限',
  'aet.bulkEdit.lastAssignmentDue': '最後の課題の提出期限',
  'aet.bulkEdit.assignmentsDueDays': '課題の提出日を選択してください。',
  'aet.bulkEdit.addEditLaterText': 'AIを使って課題を自動作成します。後から自由に課題を追加・編集することもできます。',
  'aet.bulkEdit.monday': '月曜日',
  'aet.bulkEdit.tuesday': '火曜日',
  'aet.bulkEdit.wednesday': '水曜日',
  'aet.bulkEdit.thursday': '木曜日',
  'aet.bulkEdit.friday': '金曜日',
  'aet.bulkEdit.saturday': '土曜日',
  'aet.bulkEdit.sunday': '日曜日',
  'aet.toast.assignmentCreated.title': '課題が作成されました',
  'aet.toast.assignmentCreated.single': '{assignmentTitle}という名前が自動的に付けられました',
  'aet.toast.assignmentCreated.multiple': '{count} 課題が作成されました',
  'aet.toast.assignmentUpdated.title': '更新に成功しました。',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} 更新されました',
  'aet.toast.assignmentUpdated.multiple': '{count}件の課題が更新されました',
  'aet.toast.assignmentPublished.single': '{count} assignment successfully published!',
  'aet.toast.assignmentPublished.multiple': '{count} assignments successfully published!',
  'aet.toast.assignmentPublished.subtitle': '課題の内容は、生徒が作業を開始するまで編集可能です。',
  'aet.toast.viewAssignment': '課題を表示',
  'aet.toast.viewAssignments': '課題を表示',
  'aet.welcome.title': 'PearsonのeTextbookがLMSコースに連携されました',
  'aet.welcome.LMSAccounTitle': 'インサイトを見る',
  'aet.welcome.LMSAccounDescription': 'クラスがどのトピックでつまずいているかを正確に把握しましょう。',
  'aet.welcome.createAssignmentsTitle': '課題を作成',
  'aet.welcome.createAssignmentsDescription': 'チャプターを手動で割り当てるか、シラバスをアップロードして割り当てます。',
  'aet.welcome.progressViewTitle': 'LMSで成績や学習状況を追跡',
  'aet.welcome.progressViewDescription': 'LMSのコースで成績同期の設定を選択します。',
  'aet.assignmentDetails.noAssignmentFound': '課題が見つかりません',
  'aet.assignments.loadingErrorTitle': '現在、課題を読み込めません',
  'aet.assignments.loadingErrorDescription': '再読み込みするか、後で確認してください。',
  'aet.assignmentStudentDetails.noDataFound': 'まだデータはありません',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': '生徒が登録されていません',
  'aet.studentRoster.noStudentsRegisteredYetDescription': '生徒がeTextブックを購入すると、あなたのクラスに自動的に参加します。',
  'aet.home.editAssignmentTooltipDisabled': '編集できません：学生が作業中です',
  'aet.home.deleteAssignmentTooltipDisabled': '削除できません：学生が作業中です',
  'aet.home.StudentDetails.questions': '質問',
  'aet.home.StudentDetails.attempts': '試行',
  'aet.home.StudentDetails.comprehension': '自信',
  'hero.titleInfo.tooltip': 'タイトル情報',
  'aet.home.publishAssignments': 'すべての課題を公開',
  'aet.assignments.saveScheduleAsDraft': 'スケジュールを下書きとして保存',
  'aet.assignments.reviewBeforePublishAlert': '課題の内容を確認し、公開して生徒に表示しましょう。',
  'aet.assignments.copiedCoursePublishAlert': 'コピーした課題に日付を追加し、公開して生徒が閲覧できるようにしてください。',
  'aet.assignments.allSetPublishAlert': '準備ができたら、課題を公開して生徒に表示しましょう。',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': '一部のコンテンツは、Pearsonの学習教材に基づきAIを使用して作成されています。Pearsonでは出力の検証を行っていますが、生成AIによって人物、場所、事実に関する不正確な情報が生成される場合もあります。',
  'aet.home.bulkEditTitle': '課題を一括編集',
  'aet.home.bulkEditSubtitle': 'シラバスを修正したら、ここに再アップロードしてください。課題と提出期限が自動的に更新されます。',
  'aet.home.createAssignmentTitle': '課題を作成',
  'aet.assignments.includedInAnotherAssignmentTooltip': '別の課題に含まれている',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': '一部のセクションは別の課題に含まれている',
  'aet.welcome.welcome.Title': 'ようこそ！',
  'aet.home.student.roaster.ProgressTitle': '合計完了',
  'aet.assignmentStudentDetails.startAssignmentDescription': '生徒が課題を開始したら、もう一度確認してください。',
  'aet.home.whatDueThisWeekTitle': '今週期限の宿題はこちら',
  'aet.assignments.edit.errorTitle': '{count} 課題にエラーがあります',
  'aet.assignments.edit.errorSubTitle': 'エラーのある課題は公開できません。編集するか、除外して公開してください。',
  'aet.assignments.edit.publishAnyway': 'このまま公開',
  'aet.assignments.edit.editAssignments': '課題を編集',
  'aet.assignments.edit.validationInfoToolTip': 'エラーを修正するために課題を編集',
  'aet.assignments.error.assignmentCreated.title': 'すべての課題にエラーがあります',
  'aet.assignments.error.assignmentCreated.description': 'エラーのある課題は公開できません。編集するか、別のシラバスを試してください。',
  'aet.assignments.error.uploadSyllabus': 'シラバスをアップロード',
  'aet.assignments.error.editAssignments': '課題を編集',
  'aet.mondly.title': '言語',
  'aet.studentRoster.errorState.title': '学生リストを利用できません',
  'aet.studentRoster.errorState.description': '学生リストを読み込めませんでした。更新するか、後でもう一度お試しください。',
  'aet.assignments.sectionLabel': 'セクション',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': '問題',
  'aet.assignments.assignmentsLabel': '課題',
  'aet.assignments.performanceProgressBar': '成績進捗バー',
  'aet.assignments.completionProgressBar': '完了進捗バー',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'この課題を削除してもよろしいですか？',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'これらの課題を削除してもよろしいですか？',
  'aet.home.nextAssignmentTitle': '次の課題',
  'aet.home.courseSettings': 'コース設定',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ eTextブックのリソース',
  'aet.home.etextbookInformation': 'eTextブックの情報',
  'aet.multiple.deleteAssignmentKeepCTA': '課題を保持',
  'aet.syllabus.processingText.header': 'クラスの課題のリーディングを整理しています。これには少し時間がかかります。',
  'aet.syllabus.processingText.uploading': 'ドキュメントをアップロード中',
  'aet.syllabus.processingText.activating': 'AIコンポーネントを起動しています',
  'aet.syllabus.processingText.extracting': 'リーディングの課題を抽出中',
  'aet.syllabus.processingText.mapping': '教科書の内容にマッピング中',
  'aet.syllabus.processingText.finishing': '仕上げ',
  'aet.syllabus.uploadErrorMessage': 'PDFまたは.docxが10MB以下であること、インターネット接続が安定していることを確認してください。',
  'aet.syllabus.uploadNoAssignmentsMessage': '読書課題は見つかりませんでした',
  'aet.syllabus.uploadNoAssignmentsDescription': 'このファイルから読書課題を取得できませんでした。手動で追加してください。',
  'aet.syllabus.uploadFailedRetryCTA': 'やり直す',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'シラバスに<qualities a syllabus should have for this to work>があるか再度確認し、もう一度試すか、手動で課題を作成してください。',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': '手動作成',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': '障害が発生しました',
  'aet.syllabus.uploadModal.genericFailure.body1': 'シラバスのアップロードと処理ができませんでした。',
  'aet.syllabus.uploadModal.genericFailure.body2': '接続状況を確認して再度お試しください。うまくいかない場合は、手動で課題を作成してください。',
  'aet.syllabus.uploadModal.successTotal.title': '復習の準備完了',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': '復習の準備完了',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': '課題の確認',
  'aet.syllabus.selectChapterWithQuestions': '質問のあるチャプターを選択してください。',
  'preferenceSetting.subTitle': 'これらの設定が、このコースのすべての学生のデフォルトになります。',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI機能',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'AI学習ツールと検索結果のAI要約を有効化',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'この本に関連する学習準備リソースを表示',
  'aet.syllabus.footer': '課題作成はAIで行われます',
  'aet.dashboard.footerDialogDeatils': '生成AIは、Pearsonの学習教材をもとに課題の問題を作成するために使用されています。 Pearsonでは生成された内容を検証するプロセスを設けていますが、それでも人物・場所・事実に関して不正確な情報が含まれる可能性があります。 また、提供されたシラバスやスケジュールに基づき、コンテンツを課題としてまとめて整理する目的でもAIが使用されています。',
  'aet.review.footer': 'AIを使用して作成',
  'aet.footerCard.dismiss': '解除する',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': '学習準備は、このコースに合わせた動画や練習問題を提供し、生徒の学習をサポートする追加ツールです。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': '利用プランに学習準備が含まれていない学生は、学習準備の教材を引き続き利用するために、購読（サブスクリプション）を求められる場合があります。',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'すでに学習準備を購入している学生は、この設定の影響を受けません。',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': '学習準備のメリットの詳細',
  'aet.home.viewCourseId': 'コースIDを表示',
  'aet.home.copy': 'コピー',
  'aet.home.copied': 'コピー済み',
  'aet.home.courseLabel': 'コースID:',
  'schoolInfoCard.addUniversity': '学校を追加',
  'schoolInfoCard.title': '学校情報',
  'schoolInfoCard.titleV1': 'コースについて教えてください',
  'schoolInfoCard.cta': '始めましょう',
  'schoolInfoCard.pickInstitution': '学校を選ぶ',
  'schoolInfoCard.addUniversityTitle': '学校を追加',
  'schoolInfoCard.addUniversitySubtitle': 'あなたの学校とコースがわかると、最も役立つ学習教材を提案できます。',
  'schoolInfoCard.searchPlaceholder': '学校を検索...',
  'schoolInfoCard.skip': 'この手順をスキップ',
  'schoolInfoCard.nextStep': '次のステップ',
  'schoolInfoCard.notInList': '自分の学校がリストにない',
  'schoolInfoCard.noResults': '検索条件に一致する学校は見つかりませんでした',
  'schoolInfoCard.noResultsHeading': '学校が見つかりませんか？',
  'schoolInfoCard.noResultsInstruction': '下記に氏名を入力してください',
  'schoolInfoCard.noResultsInputPlaceholder': '学校名',
  'schoolInfoCard.addInstitutionLabel': 'この学校を追加',
  'aet.assignments.assignmentTitlePlaceholder': 'タイトルを入力',
  'aet.assignments.titleValidation.titleRequired': '課題のタイトルは必須です。',
  'aet.assignments.titleValidation.titleTooLong': '課題のタイトルは{0}文字までです。',
  'aet.assignments.titleValidation.titleInvalidChar': '課題のタイトルにサポートされていない文字が含まれています。',
  'aet.assignments.titleValidation.titleDuplicate': 'その課題タイトルは既に存在します。',
  'aet.syllabus.timeZoneLabel': 'タイムゾーン',
  'aet.review.reviewReadingFromAssignments': '課題の読書を復習',
  'aet.assignments.chaptersLabel': 'チャプター',
  'menu.myAccount.subTitle': '所属組織はこちらです',
  'menu.myAccount.subTitleNotAvailable': '所属組織は、あとからいつでも追加できます。',
  'schoolInfoCard.toastMessage': '所属組織を保存しました',
  'aet.review.threeDotMenu.askAI': 'AIに聞く',
  'aet.home.suggestedRemediationSubtitle': '関連する動画を視聴し、練習問題を解いて、コースのトピックをマスターしましょう。',
  'aet.home.laggedQuestionLabel': 'フラグが付けられた質問',
  'aet.home.correctAnswer': '正解',
  'aet.home.incorrectAnswer': '最も多かった誤答',
  'aet.home.behaviourTrendsLabel': '質問に関するインサイト',
  'aet.home.strugglingStudentsLabel': '学習に苦戦している生徒',
  'aet.home.patternsInStudensAiLabel': '生徒のAI利用パターン',
  'aet.home.questionLabel': '質問',
  'aet.home.studentAskingSimilarQuestions': '類似の質問をしている生徒',
  'aet.home.assignmentDifficultQuestions': '難問',
  'aet.home.behaviorTrends': '質問に関するインサイト',
  'aet.home.behaviors': '成績指標',
  'aet.home.mostDifficultTopics': '最難問',
  'aet.home.commentsFromStudentLabel': '生徒からのコメント',
  'aet.home.disregard': '無視',
  'aet.home.reportAsInaccurate': '不正確として報告',
  'aet.home.Flagged': 'フラグ付き',
  'aet.home.reportQuestionTitle': '質問を報告',
  'aet.home.reportQuestionLabel': 'この質問の不適切な点について教えてください。',
  'aet.home.showComments': 'コメントを表示',
  'aet.home.studentReports': '生徒のレポート',
  'aet.home.placeholderText': '説明してください...',
  'aet.home.reportQuestion.notRelevant': '関連性なし',
  'aet.home.reportQuestion.notCorrect': '正しくない',
  'aet.home.reportQuestion.unsafe': '不適切/有害',
  'aet.home.reportQuestion.somethingElse': 'その他',
  'aet.home.StudentDetails.assistedByAI': 'AIの支援あり',
  'aet.home.strugglingStudents.emptyStateTitle': '現在、苦戦している生徒はいません',
  'aet.home.strugglingStudents.emptyStateDescription': '後でまた確認してください。',
  'aet.home.overallStatus.excelling': '優秀',
  'aet.home.overallStatus.fallingBehind': '伸び悩んでいる',
  'aet.home.overallStatus.keepingUp': '順調',
  'aet.home.showOnlyDifficultQuestionsLabel': '「難問」のみを表示',
  'aet.home.showOnlyStrugglingStudentsLabel': '「学習に苦戦している生徒」のみを表示する',
  'aet.home.viewQuestionInAssignment': '課題内の質問を表示',
  'aet.home.insightRisk.incorrectFirstAttempts': '初回は不正解',
  'aet.home.insightRisk.multipleIncorrectAttempts': '複数回不正解',
  'aet.home.insightRisk.lowConfidence': '自信が低い',
  'aet.home.insightRisk.mediumConfidence': '自信がある程度ある',
  'aet.home.insightRisk.lowEngagement': '関与度が低い',
  'aet.home.insightRisk.countOfStudents': '生徒{total}人のうち{count}人',
  'aet.home.insightRisk.na': 'なし',
  'aet.home.strugglingStudentsHereLabel': 'ここで苦労している生徒',
  'aet.home.insightRisk.didNotAttempt': '未回答だった',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS統合',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.'
};

export default ja;
